import React from "react";
import ReactDOM from "react-dom/client";
import { store } from "store/store";
import App from "./App";
import "./index.css";
import { Provider } from "react-redux";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { amplitude, trackEvents } from "utils/amplitude/amplitude";
import { reportWebVitals } from "utils/webVitals";

window.addEventListener("error", (e) => {
  const isChunkLoadError = e.message?.includes("Loading chunk");

  trackEvents("js_error", {
    error_message: e?.message || "Unknown error",
    error_source: e?.filename || "Unknown source",
    error_line: e?.lineno || 0,
    error_column: e?.colno || 0,
    error_stack: e?.error?.stack || "No stack trace available",
    error_type: e?.error?.name || "Error",
    is_chunk_load_error: isChunkLoadError,
  });

  if (isChunkLoadError) {
    console.warn("Detected outdated chunk, reloading app...");
    window.location.reload();
  }
});

window.addEventListener("unhandledrejection", (e) => {
  trackEvents("js_error", {
    error_message:
      e?.reason?.message || String(e?.reason) || "Unhandled promise rejection",
    error_source: "Promise rejection",
    error_line: 0,
    error_column: 0,
    error_stack: e?.reason?.stack || "No stack trace available",
    error_type: e?.reason?.name || "UnhandledRejection",
    is_chunk_load_error: false,
  });
});

const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;

amplitude?.init(amplitudeApiKey, {
  serverZone: "EU",
  autocapture: {
    pageViews: {
      eventType: "page_viewed",
    },
  },
  defaultTracking: {
    sessions: true,
  },
});

const sessionReplayTracking = sessionReplayPlugin({
  sampleRate: 1,
  debugMode: true,
});

amplitude.add(sessionReplayTracking);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
